import React, { Fragment } from 'react';

const convertList = (list, namespace, formatMessage, hasDescription) => {
  if (!list) return false;

  return list.map(item => {
    let label = item.value;
    const { className } = item;

    if (formatMessage && namespace) {
      const messageId = `${namespace}.${item.value}`;
      const descriptionId = `${namespace}.description.${item.value}`;
      if (hasDescription) {
        label = (
          <Fragment>
            <p>{formatMessage({ id: messageId })}</p>
            <If condition={hasDescription}>
              <p className="f-12 o-70">
                {formatMessage({ id: descriptionId })}
              </p>
            </If>
          </Fragment>
        );
      } else {
        label = formatMessage({ id: messageId });
      }
    }

    return {
      value: item.value,
      label,
      className,
    };
  });
};

export const convertRelationsList = (list, formatMessage, hasDescription) =>
  convertList(list, 'circles.roles', formatMessage, hasDescription);

export const convertGenderList = (list, formatMessage) =>
  convertList(list, 'profile.list.gender', formatMessage);

export const convertMaritalList = (list, formatMessage) =>
  convertList(list, 'profile.list.marital', formatMessage);

export const convertGenderIdentitiesList = list =>
  list.map(({ description, id }) => ({
    label: description,
    value: id,
  }));

export const convertListWithName = list => {
  return list.map(({ name, id, enabled }) => ({
    label: name,
    value: id,
    enabled,
  }));
};



// WEBPACK FOOTER //
// ./src/utils/converters/convertListWithLocalization.js